module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page.b9c47c90.webp";